import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/sections/Hero';
import { Partners } from '../components/sections/Partners';
import { HowItWorks } from '../components/sections/HowItWorks';
import { Benefits } from '../components/sections/Benefits';
import { ProductShowcase } from '../components/sections/ProductShowcase';
import { FAQ } from '../components/sections/FAQ';
import { CTA } from '../components/sections/CTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900" data-id="element-239">
      <Navbar data-id="element-240" />
      <main data-id="element-241">
        <Hero data-id="element-242" />
        <Partners data-id="element-243" />
        <HowItWorks data-id="element-244" />
        <Benefits data-id="element-245" />
        <ProductShowcase data-id="element-246" />
        <FAQ data-id="element-247" />
        <CTA data-id="element-248" />
      </main>
      <Footer data-id="element-249" />
    </div>;
}